import React, {useEffect, useRef} from 'react';
import {Route, Routes, useLocation} from 'react-router-dom';
import NoRoute from './app/containers/404';
import ROUTES from './routes';
import RouteWrapper from './app/components/RouteWrapper';
import Home from '../src/app/containers/Home/Index';
import Disclaimer from './app/containers/Disclaimer';
import PrivacyPolicy from './app/containers/PrivacyPolicy';
import Introduction from './app/containers/Introduction';
import HealthFactors from './app/containers/HealthFactors';
import ProceedOnPaper from './app/containers/ProceedOnPaper';
import AboutThisTool from './app/containers/AboutThisTool';
import InitialOptions from './app/containers/InitialOptions';
import EarlyInvasiveDetails from './app/containers/EarlyInvasiveDetails';
import MedicationOnlyDetails from './app/containers/MedicationOnlyDetails';
import MyRiskFactors from './app/containers/MyRiskFactors';
import WeighingInformation from './app/containers/WeighingInformation';
import BenefitsOverview from './app/containers/BenefitsOverview';
import RisksOverview from './app/containers/RisksOverview';
import SubsequentCareOverview from './app/containers/SubsequentCareOverview';
import MyPriorities from './app/containers/MyPriorities';
import Choices from './app/containers/Choices';
import DecisionAidSummary from './app/containers/DecisionAidSummary';
import SummaryReport from './app/containers/SummaryReport';
import Glossary from './app/containers/Glossary';
import NextSteps from './app/containers/NextSteps';
import HeartCondition from './app/containers/HeartCondition';

const ScrollToTop = () => {
  const {pathname} = useLocation();
  const prevPathnameRef = useRef(null);

  useEffect(() => {
    if (prevPathnameRef.current !== pathname) {
      window.scrollTo(0, 0);
    }

    prevPathnameRef.current = pathname;
  }, [pathname]);

  return null;
};

const App = function() {
  return <main className='gradient'>
    <ScrollToTop/>
    <Routes>
      <Route
        element={<RouteWrapper
          component={Home}
          title='Home'/>}
        path={ROUTES.ROOT}
      />
      <Route
        element={<RouteWrapper
          component={Introduction}
          title='Decision Aid Or Not'/>}
        path={ROUTES.INTRODUCTION}
      />
      <Route
        element={<RouteWrapper
          component={HeartCondition}
          title='Heart Condition'/>}
        path={ROUTES.HEART_CONDITION}
      />
      <Route
        element={<RouteWrapper
          component={PrivacyPolicy}
          title='Privacy Policy'/>}
        path={ROUTES.PRIVACY_POLICY}
      />
      <Route
        element={<RouteWrapper
          component={Disclaimer}
          title='Disclaimer'/>}
        path={ROUTES.DISCLAIMER}
      />
      <Route
        element={<RouteWrapper
          component={HealthFactors}
          title='Health Factors'/>}
        path={ROUTES.HEALTH_FACTORS}
      />
      <Route
        element={<RouteWrapper
          component={ProceedOnPaper}
          title='Proceed On Paper'/>}
        path={ROUTES.PROCEED_ON_PAPER}
      />
      <Route
        element={<RouteWrapper
          component={InitialOptions}
          title='Initial Options'/>}
        path={ROUTES.INITIAL_OPTIONS}
      />
      <Route
        element={<RouteWrapper
          component={EarlyInvasiveDetails}
          title='Early Invasive Details'/>}
        path={ROUTES.EARLY_INVASIVE_DETAILS}
      />
      <Route
        element={<RouteWrapper
          component={MedicationOnlyDetails}
          title='Medication Only Details'/>}
        path={ROUTES.MEDICATION_ONLY_DETAILS}
      />
      <Route
        element={<RouteWrapper
          component={MyRiskFactors}
          title='My Risk Factors'/>}
        path={ROUTES.MY_RISK_FACTORS}
      />
      <Route
        element={<RouteWrapper
          component={WeighingInformation}
          title='Weighing Information'/>}
        path={ROUTES.WEIGHING_INFORMATION}
      />
      <Route
        element={<RouteWrapper
          component={AboutThisTool}
          title='About This Tool'/>}
        path={ROUTES.ABOUT_THIS_TOOL}
      />
      <Route
        element={<RouteWrapper
          component={BenefitsOverview}
          title='Benefits Overview'/>}
        path={ROUTES.BENEFITS_OVERVIEW}
      />
      <Route
        element={<RouteWrapper
          component={RisksOverview}
          title='Risks Overview'/>}
        path={ROUTES.RISKS_OVERVIEW}
      />
      <Route
        element={<RouteWrapper
          component={SubsequentCareOverview}
          title='Subsequent Care'/>}
        path={ROUTES.SUBSEQUENT_CARE_OVERVIEW}
      />
      <Route
        element={<RouteWrapper
          component={MyPriorities}
          title='My Priorities'/>}
        path={ROUTES.MY_PRIORITIES}
      />
      <Route
        element={<RouteWrapper
          component={Choices}
          title='Choices'/>}
        path={ROUTES.CHOICES}
      />
      <Route
        element={<RouteWrapper
          component={NextSteps}
          title='Next Steps'/>}
        path={ROUTES.NEXT_STEPS}
      />
      <Route
        element={<RouteWrapper
          component={DecisionAidSummary}
          title='Decision Aid Summary'/>}
        path={ROUTES.DECISION_AID_SUMMARY}
      />
      <Route
        element={<RouteWrapper
          component={SummaryReport}
          title='Summary Report'/>}
        path={ROUTES.SUMMARY_REPORT}
      />
      <Route
        element={<RouteWrapper
          component={Glossary}
          title='Glossary'/>}
        path={ROUTES.GLOSSARY}
      />
      <Route
        element={<RouteWrapper
          component={NoRoute}
          title='404'/>}
        path='*'
      />
    </Routes>
  </main>;
};

export default App;
